export interface VendorResponse {
  success: boolean;
  available: boolean;
  vendors: Vendor[];
}

export interface Vendor {
  id: number;
  vendor_name: string;
  token: string;
  account: null;
  merchant: null | string;
  is_test: boolean;
  active: boolean;
  expresotec_id: number;
  created_at: Date;
  updated_at: Date;
  deleted_at: null | Date;
}

export enum VendorName {
  DigitalFemsa = 'DigitalFemsa',
  Conekta = 'Conekta',
  OpenPay = 'OpenPay',
  PayPal = 'PayPal',
  PayU = 'PayU',
  PayCode = 'PayCode',
}
